import React from "react";
import "../loader/style.scss";

const ref = React.createRef();
const hideLoader = () => {
  var name = ref.current;
  if(name) name.style.display = "none";
};
const showLoader = () => {
  var name = ref.current;
  if(name) name.style.display = "block";
};

class CustomLoader extends React.Component {
  render() {
    return (
      <div>
        <div ref={ref} className="loading" style={{ display: "none" }}>
          <div className="loader-08"></div>
        </div>
      </div>
    );
  }
}

export default CustomLoader;
export { hideLoader, showLoader };
